import { inject } from '@aesop-fables/containr';
import { ISubject, DataCache, ScriniumServices } from '@aesop-fables/scrinium';
import type { IAppStorage } from '@aesop-fables/scrinium';
import { Observable } from 'rxjs';
import { RevShareResult } from '../../../models/RevShareData';
import { RevShareCompartments, revShareStorageKey } from '..';

export class OrgRevShareSettingsSubject implements ISubject<RevShareResult | undefined> {
  private readonly cache: DataCache<RevShareCompartments>;

  constructor(@inject(ScriniumServices.AppStorage) private readonly storage: IAppStorage) {
    this.cache = this.storage.retrieve<RevShareCompartments>(revShareStorageKey);
  }

  createObservable(): Observable<RevShareResult | undefined> {
    return this.cache.observe$<RevShareResult | undefined>('orgRevShareSettings');
  }
}

export class TeamRevShareSettingsSubject implements ISubject<RevShareResult | undefined> {
  private readonly cache: DataCache<RevShareCompartments>;

  constructor(@inject(ScriniumServices.AppStorage) private readonly storage: IAppStorage) {
    this.cache = this.storage.retrieve<RevShareCompartments>(revShareStorageKey);
  }

  createObservable(): Observable<RevShareResult | undefined> {
    return this.cache.observe$<RevShareResult | undefined>('teamRevShareSettings');
  }
}

export class GroupRevShareSettingsSubject implements ISubject<RevShareResult | undefined> {
  private readonly cache: DataCache<RevShareCompartments>;

  constructor(@inject(ScriniumServices.AppStorage) private readonly storage: IAppStorage) {
    this.cache = this.storage.retrieve<RevShareCompartments>(revShareStorageKey);
  }

  createObservable(): Observable<RevShareResult | undefined> {
    return this.cache.observe$<RevShareResult | undefined>('groupRevShareSettings');
  }
}
